import { wpDomainHappyRain } from "app/configs/wp.config";

// const domain = "http://localhost:6699";
// const domain = "http://localhost:3000";

const baseURL = `${wpDomainHappyRain}/api`;
const accessTokenKey = "access_token";

const apiConfig = {
  baseURL,
  accessTokenKey,
};

export default apiConfig;
